import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  claimsEditModalMobileModalSubject = new BehaviorSubject(false);
  claimsEditModalMobileModalObservable = this.claimsEditModalMobileModalSubject.asObservable();
  cancelEmergencyServiceSubject = new BehaviorSubject(null);
  cancelEmergencyServiceObservable = this.cancelEmergencyServiceSubject.asObservable();
  requestEmergencyServiceSubject = new BehaviorSubject(null);
  requestEmergencyServiceObservable = this.requestEmergencyServiceSubject.asObservable();

  constructor() { }

  setClaimsEditModalMobileModalSubject(value: boolean): void {
    this.claimsEditModalMobileModalSubject.next(value);
  }

  setCancelEmergencyServiceSubject(item: any): void {
    this.cancelEmergencyServiceSubject.next(item);
  }

  setRequestEmergencyServiceSubject(item: any): void {
    this.requestEmergencyServiceSubject.next(item);
  }


}
